var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRobot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9624 4.375H4.7124C3.67687 4.375 2.8374 5.21447 2.8374 6.25V15C2.8374 16.0355 3.67687 16.875 4.7124 16.875H15.9624C16.9979 16.875 17.8374 16.0355 17.8374 15V6.25C17.8374 5.21447 16.9979 4.375 15.9624 4.375Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1499 11.25H7.5249C6.66196 11.25 5.9624 11.9496 5.9624 12.8125C5.9624 13.6754 6.66196 14.375 7.5249 14.375H13.1499C14.0128 14.375 14.7124 13.6754 14.7124 12.8125C14.7124 11.9496 14.0128 11.25 13.1499 11.25Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8999 11.25V14.375",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7749 11.25V14.375",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3374 4.375V1.25",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8999 9.375C7.41767 9.375 7.8374 8.95527 7.8374 8.4375C7.8374 7.91973 7.41767 7.5 6.8999 7.5C6.38214 7.5 5.9624 7.91973 5.9624 8.4375C5.9624 8.95527 6.38214 9.375 6.8999 9.375Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7749 9.375C14.2927 9.375 14.7124 8.95527 14.7124 8.4375C14.7124 7.91973 14.2927 7.5 13.7749 7.5C13.2571 7.5 12.8374 7.91973 12.8374 8.4375C12.8374 8.95527 13.2571 9.375 13.7749 9.375Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8374 8.125H1.6499C1.09762 8.125 0.649902 8.57272 0.649902 9.125V12.125C0.649902 12.6773 1.09762 13.125 1.6499 13.125H2.8374",
    stroke: "white",
    strokeWidth: 1.3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8374 8.125H19.0249C19.5772 8.125 20.0249 8.57272 20.0249 9.125V12.125C20.0249 12.6773 19.5772 13.125 19.0249 13.125H17.8374",
    stroke: "white",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot);
export default __webpack_public_path__ + "static/media/robot.c0bfaa4cf02d466009b64992b0e838e8.svg";
export { ForwardRef as ReactComponent };